import NewsParagraph from "../components/NewsParagraph.tsx";
import ArticleContainer from "../components/ArticleContainer.tsx";

function Flash3() {
  return (
    <ArticleContainer>
      <NewsParagraph>
        Deepfake Video of Presidential Candidate Causes Political Turmoil
      </NewsParagraph>
      <NewsParagraph>August 6, 2024</NewsParagraph>
      <NewsParagraph>
        WASHINGTON, D.C. (CNN) – A deepfake video showing a leading presidential
        candidate making inflammatory remarks about minority groups has thrown
        the upcoming election into chaos. The video, which circulated widely on
        social media platforms before being identified as fake, has already
        influenced voter opinions and campaign strategies.
      </NewsParagraph>
      <NewsParagraph>
        The deepfake was created using advanced AI technology that perfectly
        mimicked the candidate's voice, facial expressions, and mannerisms. Even
        after the video was debunked by forensic experts, polls indicate that a
        significant percentage of voters still believe the content was genuine.
      </NewsParagraph>
      <NewsParagraph>
        "This is a direct attack on our democratic process," said campaign
        spokesperson Jordan Taylor. "The damage has been done, despite our
        efforts to correct the record. We're seeing how AI can be weaponized to
        manipulate elections in ways we weren't prepared for."
      </NewsParagraph>
      <NewsParagraph>
        The incident has prompted urgent calls for legislation to combat
        deepfakes in political contexts and for social media platforms to
        implement more robust verification systems. As the election approaches,
        there are fears that this may be just the first in a wave of
        AI-generated misinformation designed to sway voters.
      </NewsParagraph>
    </ArticleContainer>
  );
}

export default Flash3;
